import Vue from 'vue';

class EventBus {
  constructor() {
    this.init()
    this.choCateKey = 'chooseCategoryKey'
    this.choTagKey = 'chooseTagKey'
    this.choGoodKey = 'chooseGoodKey'

    return this
  }
  init () {
    this.localBus = new Vue()
  }

  chooseCategory(data) {
    this.localBus.$emit(this.choCateKey,data)
  }

  getCategory(fn) {
    if(this.isBindCate) {
      return
    }
    this.localBus.$on(this.choCateKey, (data) => {
      fn && fn(data)
    })
    this.isBindCate = true
  }

  chooseTags(data) {
    this.localBus.$emit(this.choTagKey,data)
  }

  getTags(fn) {
    if(this.isBindTag) {
      return
    }
    this.localBus.$on(this.choTagKey,(data) => {
      fn && fn(data)
    })
    this.isBindTag = true
  }

  setGoodFunc(fn) {
    this.localBus.$on(this.choGoodKey, (data) => {
      fn && fn(data)
    })
  }

  chooseGoodFunc(data) {
    this.localBus.$emit(this.choGoodKey,data)
  }

  clearAll() {
    this.localBus.$off(this.choCateKey)
    this.localBus.$off(this.choTagKey)
    this.localBus.$off(this.choGoodKey)
  }
}

export default new EventBus(); 